import { createApi } from '@/api'
export default {
	getFarmerList: config => createApi( `/farmer/pageSearch`, 'post', config ),
	farmerDetail: config => createApi(`/farmer/get`, 'get', config),
	addfarmer: config => createApi(`/farmer/add`, 'post', config),
	deletefarmer: config => createApi(`/farmer/delete`, 'delete', config),
	updatefarmer: config => createApi(`/farmer/update`, 'post', config)
}



// WEBPACK FOOTER //
// ./src/views/farmerManage/api/index.js